var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white relative"},[_c('div',{staticClass:"mt-24"},[_c('div',{staticClass:"lg:px-20 md:px-20 px-4"},[_c('Products')],1)]),_c('WhatWeDo'),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555"},[_c('Download'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }